import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { AssinantePjResponse, ReportCertificadoRegularidadePjRequest, ReportCertificadoRegularidadePjResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './certificado-regularidade-pj.model';

/** Cliente HTTP do relatório assíncrono Certificado de Regularidade de Inscrição PJ. */
@Injectable({ providedIn: 'root' })
export class CertificadoRegularidadePjService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.prestador.reports.certificadoRegularidadePj;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Lista os assinantes vigentes da diretoria do órgão da UF (QryAssinantes do legado). */
    listarAssinantes(uf: string): Observable<AssinantePjResponse[]> {
        return this.http.get<AssinantePjResponse[]>(`${this.PATH}/assinantes`, { params: { uf } });
    }

    exportarPdf(request: ReportCertificadoRegularidadePjRequest): Observable<HttpResponse<ReportCertificadoRegularidadePjResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportCertificadoRegularidadePjResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportCertificadoRegularidadePjRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
